<nav class="navbar bg-body-tertiary fixed-top">
  <div class="container">
    <img height="40px" src="https://storage.googleapis.com/komerce/assets/Affiliate/Komerce%20Affiliate.svg" alt="">
  </div>
</nav>